import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import NewsPage from "@/pages/news/page";
import NewsDetailPage from "@/pages/news/detail/page";
import WorksPage from "@/pages/works/page";
import WorkDetailPage from "@/pages/works/detail/page";
import ProfilePage from "@/pages/profile/page";
import FanInteractionPage from "@/pages/fan-interaction/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "news", element: <NewsPage /> },
      { path: "news/:id", element: <NewsDetailPage /> },
      { path: "works", element: <WorksPage /> },
      { path: "works/:id", element: <WorkDetailPage /> },
      { path: "profile", element: <ProfilePage /> },
      { path: "fan-interaction", element: <FanInteractionPage /> },
      { path: "about", element: <AboutPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;